/**
 * Common tracking props that are used by room content details, room
 * content tile and sales actions. These are "simplified" because those components
 * can figure out the other props (contentId or version) from their own content prop
 */
export interface SimplifiedTrackingProps {
  contactId?: string;
  roomId?: string;
  track?: boolean;
}

export interface ContentTrackerProps extends SimplifiedTrackingProps {
  contentId: string;
  version?: number;
}

export enum Actions {
  AssethubSessionStart = 'ASSETHUB_SESSION_START',
}

export interface ExternalPayload {
  action: Actions;
  data: {
    sessionId: string;
    dsrData: {
      viewType: string;
    };
  };
}
